import React from 'react'
import { Link } from 'react-router-dom'
import SEOHead from '../components/SEOHead'
import './PontoonTrailersPage.css'

interface PontoonModel {
  model: string;
  capacity: number;
  boatLength: string;
  overallLength: string;
  minBunkWidth: string;
  maxBunkWidth: string;
  gvwr: number;
  tongueJack: string;
  axles: number;
  brakes: string;
  tireSize: string;
  overallWidth: string;
  betweenFenders: string;
}

const PontoonTrailersPage: React.FC = () => {
  // Single Axle Pontoon Trailers
  const singleAxleModels: PontoonModel[] = [
    {
      model: "VP-18-20",
      capacity: 2000,
      boatLength: "17'-19'",
      overallLength: "23'3\"",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 2760,
      tongueJack: "Optional",
      axles: 1,
      brakes: "Optional",
      tireSize: "ST175 80R13 LRD",
      overallWidth: "98\"",
      betweenFenders: "78\""
    },
    {
      model: "VP-18-27",
      capacity: 2700,
      boatLength: "17'-19'",
      overallLength: "23'3\"",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 3488,
      tongueJack: "Optional",
      axles: 1,
      brakes: "Optional*",
      tireSize: "ST215 75R14 LRC",
      overallWidth: "98\"",
      betweenFenders: "78\""
    },
    {
      model: "VP-20-20",
      capacity: 2000,
      boatLength: "19'-21'",
      overallLength: "25'3\"",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 2780,
      tongueJack: "Optional",
      axles: 1,
      brakes: "Optional",
      tireSize: "ST175 80R13 LRD",
      overallWidth: "98\"",
      betweenFenders: "78\""
    },
    {
      model: "VP-20-25",
      capacity: 2500,
      boatLength: "19'-21'",
      overallLength: "25'3\"",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 3280,
      tongueJack: "Optional",
      axles: 1,
      brakes: "Optional",
      tireSize: "ST185 80R13 LRD",
      overallWidth: "98\"",
      betweenFenders: "78\""
    },
    {
      model: "VP-22-25",
      capacity: 2500,
      boatLength: "19'-22'",
      overallLength: "26'3\"",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 3420,
      tongueJack: "Optional",
      axles: 1,
      brakes: "Optional",
      tireSize: "ST185 80R13 LRD",
      overallWidth: "98\"",
      betweenFenders: "78\""
    },
    {
      model: "VP-24-25",
      capacity: 2500,
      boatLength: "22'-25'",
      overallLength: "31'",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 3440,
      tongueJack: "Optional",
      axles: 1,
      brakes: "Optional",
      tireSize: "ST185 80R13 LRD",
      overallWidth: "98\"",
      betweenFenders: "78\""
    }
  ];

  // Tandem Axle Pontoon Trailers
  const tandemAxleModels: PontoonModel[] = [
    {
      model: "VPT-18-32",
      capacity: 3200,
      boatLength: "17'-19'",
      overallLength: "23'3\"",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 4185,
      tongueJack: "Single Wheel",
      axles: 2,
      brakes: "Disc-1",
      tireSize: "ST175 80R13 LRC",
      overallWidth: "98\"",
      betweenFenders: "78\""
    },
    {
      model: "VPT-22-32",
      capacity: 3200,
      boatLength: "19'-22'",
      overallLength: "26'3\"",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 4320,
      tongueJack: "Single Wheel",
      axles: 2,
      brakes: "Disc-1",
      tireSize: "ST175 80R13 LRC",
      overallWidth: "98\"",
      betweenFenders: "78\""
    },
    {
      model: "VPT-22-40",
      capacity: 4000,
      boatLength: "19'-22'",
      overallLength: "26'3\"",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 5120,
      tongueJack: "Single Wheel",
      axles: 2,
      brakes: "Disc-1",
      tireSize: "ST175 80R13 LRC",
      overallWidth: "98\"",
      betweenFenders: "78\""
    },
    {
      model: "VPT-22-50",
      capacity: 5000,
      boatLength: "19'-22'",
      overallLength: "26'3\"",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 6120,
      tongueJack: "Single Wheel",
      axles: 2,
      brakes: "Disc-1",
      tireSize: "ST185 80R13 LRD",
      overallWidth: "98\"",
      betweenFenders: "78\""
    },
    {
      model: "VPT-24-40",
      capacity: 4000,
      boatLength: "23'-25'",
      overallLength: "31'",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 5140,
      tongueJack: "Single Wheel",
      axles: 2,
      brakes: "Disc-1",
      tireSize: "ST175 80R13 LRC",
      overallWidth: "98\"",
      betweenFenders: "78\""
    },
    {
      model: "VPT-24-50",
      capacity: 5000,
      boatLength: "23'-25'",
      overallLength: "31'",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 6160,
      tongueJack: "Single Wheel",
      axles: 2,
      brakes: "Disc-1",
      tireSize: "ST185 80R13 LRD",
      overallWidth: "98\"",
      betweenFenders: "78\""
    },
    {
      model: "VPT-26-40",
      capacity: 4000,
      boatLength: "23'-26'",
      overallLength: "32'",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 5160,
      tongueJack: "Single Wheel",
      axles: 2,
      brakes: "Disc-1",
      tireSize: "ST175 80R13 LRC",
      overallWidth: "98\"",
      betweenFenders: "78\""
    },
    {
      model: "VPT-26-50",
      capacity: 5000,
      boatLength: "23'-26'",
      overallLength: "32'",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 6160,
      tongueJack: "Single Wheel",
      axles: 2,
      brakes: "Disc-1",
      tireSize: "ST185 80R13 LRD",
      overallWidth: "98\"",
      betweenFenders: "78\""
    }
  ];

  // Triple Axle Pontoon Trailers
  const tripleAxleModels: PontoonModel[] = [
    {
      model: "VPT-26-65",
      capacity: 6500,
      boatLength: "23'-26'",
      overallLength: "32'6\"",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 8100,
      tongueJack: "2000lb Foot",
      axles: 3,
      brakes: "Disc-2",
      tireSize: "ST175 80R 13LRC",
      overallWidth: "98\"",
      betweenFenders: "78\""
    }
  ];

  // Single Axle Tritoon Trailers
  const singleAxleTritoonModels: PontoonModel[] = [
    {
      model: "VP-18-20TRI",
      capacity: 2000,
      boatLength: "17'-19'",
      overallLength: "23'3\"",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 2840,
      tongueJack: "Optional",
      axles: 1,
      brakes: "Optional",
      tireSize: "ST175/80R 13 LRD",
      overallWidth: "98\"",
      betweenFenders: "78\""
    },
    {
      model: "VP-20-25TRI",
      capacity: 2500,
      boatLength: "19'-21'",
      overallLength: "25'3\"",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 3330,
      tongueJack: "Optional",
      axles: 1,
      brakes: "Optional",
      tireSize: "ST185/80R 13 LRD",
      overallWidth: "98\"",
      betweenFenders: "78\""
    },
    {
      model: "VP-22-27TRI",
      capacity: 2700,
      boatLength: "19'-22'",
      overallLength: "26'3\"",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 3720,
      tongueJack: "Optional",
      axles: 1,
      brakes: "Optional",
      tireSize: "ST215/75R 14 LRC",
      overallWidth: "98\"",
      betweenFenders: "78\""
    }
  ];

  // Tandem Axle Tritoon Trailers
  const tandemAxleTritoonModels: PontoonModel[] = [
    {
      model: "VPT-22-40TRI",
      capacity: 4000,
      boatLength: "19'-22'",
      overallLength: "26'3\"",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 5200,
      tongueJack: "Single Wheel",
      axles: 2,
      brakes: "Disc-1",
      tireSize: "ST175/80R 13 LRC",
      overallWidth: "98\"",
      betweenFenders: "78\""
    },
    {
      model: "VPT-24-50TRI",
      capacity: 5000,
      boatLength: "23'-25'",
      overallLength: "31'",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 6260,
      tongueJack: "Single Wheel",
      axles: 2,
      brakes: "Disc-1",
      tireSize: "ST185/80R 13 LRD",
      overallWidth: "98\"",
      betweenFenders: "78\""
    }
  ];

  // Triple Axle Tritoon Trailers
  const tripleAxleTritoonModels: PontoonModel[] = [
    {
      model: "VPT-26-65TRI",
      capacity: 6500,
      boatLength: "23'-26'",
      overallLength: "36'6\"",
      minBunkWidth: "72\"",
      maxBunkWidth: "80\"",
      gvwr: 8150,
      tongueJack: "2000lb Foot",
      axles: 3,
      brakes: "Disc-2",
      tireSize: "ST175/80R 13 LRC",
      overallWidth: "98\"",
      betweenFenders: "78\""
    }
  ];

  const pontoonTrailerFeatures = [
    "Plug & Play Lights",
    "Aluminum Diamond Plate Fenders",
    "Heavy Duty Winch Straps",
    "D.O.T. Composite Brake Line with Brass Fittings",
    "Balanced Radial Tires",
    "Eliminator GalvX Vented Rotor Disc Brakes",
    "Super Lube Spindles",
    "Wheel Balancing",
    "Galvanized Hardware, U-bolts, Winch Stand, Axles, Tongue",
    "Ladder with safety handrail",
    "Poly bunk sleeve for hull protection",
    "Inside load guides for easy alignment",
    "Adjustable bunk width (72\" to 80\" center-to-center)",
    "Hot-dip galvanizing for maximum corrosion resistance"
  ];

  return (
    <div className="pontoon-page">
      <SEOHead
        title="Pontoon Boat Trailers - Wide Deck Support | Fast Boat Trailers"
        description="Pontoon boat trailers from Fast Boat Trailers in Edgewater, MD. Adjustable width bunk design for pontoon boats 17'-28'. Aluminum and galvanized models with heavy-duty capacity ratings."
        keywords="pontoon trailers, pontoon boat trailers Maryland, wide deck trailers, adjustable bunk trailers, aluminum pontoon trailers"
        ogTitle="Pontoon Boat Trailers - Wide Deck Support"
        ogDescription="Pontoon boat trailers with adjustable width bunks for secure pontoon transport. Heavy-duty capacity ratings for boats 17'-28'."
        ogImage="/images/trailers/pontoon.jpg"
        canonical="https://fastboattrailers.com/trailers/pontoon"
      />
      <div className="container">
        {/* Hero Section */}
        <div className="pontoon-hero">
          <div className="hero-main">
            <div className="hero-content">
              <h1>Pontoon/Tritoon Trailers</h1>
              <h2>Built for Pontoon & Tritoon Boat Transport</h2>
              <p>
                Our Pontoon and Tritoon Trailers support a range of pontoon and tritoon boat sizes from 17 to 26 feet. We manufacture trailers with your needs in mind.
                Select single, tandem, or triple axle, depending on your transport needs, boat size, and load-carrying capacity.
                Each trailer is made from hot-dipped galvanized steel to support your boat from travel to launch.
              </p>
              
              <h3>Benefits of Pontoon & Tritoon Trailers</h3>
              <ul className="benefits-list">
                <li>Ladder with safety handrail for easy access</li>
                <li>Poly bunk sleeve for hull protection</li>
                <li>Inside load guides for proper alignment</li>
                <li>Hot-dip galvanizing provides excellent corrosion resistance</li>
                <li>Tubular frame design protects wiring and brake lines</li>
                <li>Specialized design for both two and three-pontoon configurations</li>
              </ul>
            </div>
            <div className="hero-features">
              <h3>Standard Features</h3>
              <div className="features-compact">
                {pontoonTrailerFeatures.map((feature, index) => (
                  <div key={index} className="feature-item-compact">
                    <div className="feature-icon-compact">✓</div>
                    <span>{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Special Features Section */}
        <div className="special-features-section">
          <div className="feature-image">
            <img src="/images/trailers/pontoon-ladder-guides.png" alt="Pontoon Trailer Ladder with Safety Rail and Inside Load Guides" />
          </div>
          <div className="feature-content">
            <h2>Designed for Pontoon Boats</h2>
            <p>
              Our pontoon trailers feature specialized design elements that make transporting pontoon boats safe and convenient. 
              The ladder with safety handrail provides secure access, while inside load guides ensure proper boat alignment during loading.
            </p>
            <div className="feature-highlights">
              <div className="highlight-item">
                <h4>Safety Ladder</h4>
                <p>Integrated ladder with handrail for safe and easy boat access</p>
              </div>
              <div className="highlight-item">
                <h4>Load Guides</h4>
                <p>Inside guides help align your pontoon boat perfectly every time</p>
              </div>
              <div className="highlight-item">
                <h4>Adjustable Bunks</h4>
                <p>Bunk width adjusts from 72" to 80" center-to-center for perfect fit</p>
              </div>
            </div>
          </div>
        </div>

        {/* Single Axle Pontoon Trailers Section */}
        <div className="models-section">
          <h2>Single Axle Pontoon Trailers</h2>
          
          <div className="model-category">
            <div className="category-image-full">
              <img src="/images/trailers/pontoon-galvanized-single-axle.jpg" alt="Single Axle Pontoon Trailers" />
            </div>
            <div className="category-header">
              <h3>Single Axle Models</h3>
              <p>Perfect for smaller pontoon boats from 17-25 feet. Single axle design with capacity ranges from 2,000 to 2,700 lbs. Optional brakes available on most models.</p>
            </div>
            <div className="models-table-container">
              <table className="models-table">
                <thead>
                  <tr>
                    <th>Model</th>
                    <th>Capacity (lbs)</th>
                    <th>Boat Length</th>
                    <th>Overall Length</th>
                    <th>Bunk Width Min</th>
                    <th>Bunk Width Max</th>
                    <th>GVWR</th>
                    <th>Tongue Jack</th>
                    <th>Brakes</th>
                    <th>Tire Size</th>
                    <th>Overall Width</th>
                  </tr>
                </thead>
                <tbody>
                  {singleAxleModels.map((model, index) => (
                    <tr key={index}>
                      <td className="model-name">{model.model}</td>
                      <td>{model.capacity.toLocaleString()}</td>
                      <td>{model.boatLength}</td>
                      <td>{model.overallLength}</td>
                      <td>{model.minBunkWidth}</td>
                      <td>{model.maxBunkWidth}</td>
                      <td>{model.gvwr.toLocaleString()}</td>
                      <td>{model.tongueJack}</td>
                      <td>{model.brakes}</td>
                      <td>{model.tireSize}</td>
                      <td>{model.overallWidth}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Tandem Axle Pontoon Trailers Section */}
        <div className="models-section">
          <h2>Tandem Axle Pontoon Trailers</h2>
          
          <div className="model-category">
            <div className="category-image-full">
              <img src="/images/trailers/pontoon-galvanized-tandem-axle.jpg" alt="Tandem Axle Pontoon Trailers" />
            </div>
            <div className="category-header">
              <h3>Tandem Axle Models</h3>
              <p>Heavy-duty tandem axle design for larger pontoon boats from 17-26 feet. Superior load distribution with capacity ranges from 3,200 to 5,000 lbs. Standard disc brakes on one axle.</p>
            </div>
            <div className="models-table-container">
              <table className="models-table">
                <thead>
                  <tr>
                    <th>Model</th>
                    <th>Capacity (lbs)</th>
                    <th>Boat Length</th>
                    <th>Overall Length</th>
                    <th>Bunk Width Min</th>
                    <th>Bunk Width Max</th>
                    <th>GVWR</th>
                    <th>Tongue Jack</th>
                    <th>Brakes</th>
                    <th>Tire Size</th>
                    <th>Overall Width</th>
                  </tr>
                </thead>
                <tbody>
                  {tandemAxleModels.map((model, index) => (
                    <tr key={index}>
                      <td className="model-name">{model.model}</td>
                      <td>{model.capacity.toLocaleString()}</td>
                      <td>{model.boatLength}</td>
                      <td>{model.overallLength}</td>
                      <td>{model.minBunkWidth}</td>
                      <td>{model.maxBunkWidth}</td>
                      <td>{model.gvwr.toLocaleString()}</td>
                      <td>{model.tongueJack}</td>
                      <td>{model.brakes}</td>
                      <td>{model.tireSize}</td>
                      <td>{model.overallWidth}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Triple Axle Pontoon Trailers Section */}
        <div className="models-section">
          <h2>Triple Axle Pontoon Trailers</h2>
          
          <div className="model-category">
            <div className="category-image-full">
              <img src="/images/trailers/pontoon-galvanized-triple-axle.jpg" alt="Triple Axle Pontoon Trailers" />
            </div>
            <div className="category-header">
              <h3>Triple Axle Models</h3>
              <p>Maximum capacity triple axle design for the largest pontoon boats from 23-26 feet. Ultimate load distribution and stability with 6,500 lbs capacity. Heavy-duty disc brakes on two axles.</p>
            </div>
            <div className="models-table-container">
              <table className="models-table">
                <thead>
                  <tr>
                    <th>Model</th>
                    <th>Capacity (lbs)</th>
                    <th>Boat Length</th>
                    <th>Overall Length</th>
                    <th>Bunk Width Min</th>
                    <th>Bunk Width Max</th>
                    <th>GVWR</th>
                    <th>Tongue Jack</th>
                    <th>Brakes</th>
                    <th>Tire Size</th>
                    <th>Overall Width</th>
                  </tr>
                </thead>
                <tbody>
                  {tripleAxleModels.map((model, index) => (
                    <tr key={index}>
                      <td className="model-name">{model.model}</td>
                      <td>{model.capacity.toLocaleString()}</td>
                      <td>{model.boatLength}</td>
                      <td>{model.overallLength}</td>
                      <td>{model.minBunkWidth}</td>
                      <td>{model.maxBunkWidth}</td>
                      <td>{model.gvwr.toLocaleString()}</td>
                      <td>{model.tongueJack}</td>
                      <td>{model.brakes}</td>
                      <td>{model.tireSize}</td>
                      <td>{model.overallWidth}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Single Axle Tritoon Trailers Section */}
        <div className="models-section">
          <h2>Single Axle Tritoon Trailers</h2>
          
          <div className="model-category">
            <div className="category-image-full">
              <img src="/images/trailers/tritoon-single-axle.jpg" alt="Single Axle Tritoon Trailers" />
            </div>
            <div className="category-header">
              <h3>Single Axle Tritoon Models</h3>
              <p>Specialized trailers designed for three-pontoon boats from 17-22 feet. Single axle design with capacity ranges from 2,000 to 2,700 lbs. Built for tritoon configuration with superior stability.</p>
            </div>
            <div className="models-table-container">
              <table className="models-table">
                <thead>
                  <tr>
                    <th>Model</th>
                    <th>Capacity (lbs)</th>
                    <th>Boat Length</th>
                    <th>Overall Length</th>
                    <th>Bunk Width Min</th>
                    <th>Bunk Width Max</th>
                    <th>GVWR</th>
                    <th>Tongue Jack</th>
                    <th>Brakes</th>
                    <th>Tire Size</th>
                    <th>Overall Width</th>
                  </tr>
                </thead>
                <tbody>
                  {singleAxleTritoonModels.map((model, index) => (
                    <tr key={index}>
                      <td className="model-name">{model.model}</td>
                      <td>{model.capacity.toLocaleString()}</td>
                      <td>{model.boatLength}</td>
                      <td>{model.overallLength}</td>
                      <td>{model.minBunkWidth}</td>
                      <td>{model.maxBunkWidth}</td>
                      <td>{model.gvwr.toLocaleString()}</td>
                      <td>{model.tongueJack}</td>
                      <td>{model.brakes}</td>
                      <td>{model.tireSize}</td>
                      <td>{model.overallWidth}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Tandem Axle Tritoon Trailers Section */}
        <div className="models-section">
          <h2>Tandem Axle Tritoon Trailers</h2>
          
          <div className="model-category">
            <div className="category-image-full">
              <img src="/images/trailers/tritoon-tandem-axle.jpg" alt="Tandem Axle Tritoon Trailers" />
            </div>
            <div className="category-header">
              <h3>Tandem Axle Tritoon Models</h3>
              <p>Heavy-duty tandem axle design for larger tritoon boats from 19-25 feet. Superior load distribution with capacity ranges from 4,000 to 5,000 lbs. Standard disc brakes on one axle.</p>
            </div>
            <div className="models-table-container">
              <table className="models-table">
                <thead>
                  <tr>
                    <th>Model</th>
                    <th>Capacity (lbs)</th>
                    <th>Boat Length</th>
                    <th>Overall Length</th>
                    <th>Bunk Width Min</th>
                    <th>Bunk Width Max</th>
                    <th>GVWR</th>
                    <th>Tongue Jack</th>
                    <th>Brakes</th>
                    <th>Tire Size</th>
                    <th>Overall Width</th>
                  </tr>
                </thead>
                <tbody>
                  {tandemAxleTritoonModels.map((model, index) => (
                    <tr key={index}>
                      <td className="model-name">{model.model}</td>
                      <td>{model.capacity.toLocaleString()}</td>
                      <td>{model.boatLength}</td>
                      <td>{model.overallLength}</td>
                      <td>{model.minBunkWidth}</td>
                      <td>{model.maxBunkWidth}</td>
                      <td>{model.gvwr.toLocaleString()}</td>
                      <td>{model.tongueJack}</td>
                      <td>{model.brakes}</td>
                      <td>{model.tireSize}</td>
                      <td>{model.overallWidth}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Triple Axle Tritoon Trailers Section */}
        <div className="models-section">
          <h2>Triple Axle Tritoon Trailers</h2>
          
          <div className="model-category">
            <div className="category-image-full">
              <img src="/images/trailers/tritoon-triple-axle.jpg" alt="Triple Axle Tritoon Trailers" />
            </div>
            <div className="category-header">
              <h3>Triple Axle Tritoon Models</h3>
              <p>Maximum capacity triple axle design for the largest tritoon boats from 23-26 feet. Ultimate load distribution and stability with 6,500 lbs capacity. Heavy-duty disc brakes on two axles.</p>
            </div>
            <div className="models-table-container">
              <table className="models-table">
                <thead>
                  <tr>
                    <th>Model</th>
                    <th>Capacity (lbs)</th>
                    <th>Boat Length</th>
                    <th>Overall Length</th>
                    <th>Bunk Width Min</th>
                    <th>Bunk Width Max</th>
                    <th>GVWR</th>
                    <th>Tongue Jack</th>
                    <th>Brakes</th>
                    <th>Tire Size</th>
                    <th>Overall Width</th>
                  </tr>
                </thead>
                <tbody>
                  {tripleAxleTritoonModels.map((model, index) => (
                    <tr key={index}>
                      <td className="model-name">{model.model}</td>
                      <td>{model.capacity.toLocaleString()}</td>
                      <td>{model.boatLength}</td>
                      <td>{model.overallLength}</td>
                      <td>{model.minBunkWidth}</td>
                      <td>{model.maxBunkWidth}</td>
                      <td>{model.gvwr.toLocaleString()}</td>
                      <td>{model.tongueJack}</td>
                      <td>{model.brakes}</td>
                      <td>{model.tireSize}</td>
                      <td>{model.overallWidth}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="pontoon-cta">
          <h2>Ready for Your Next Pontoon Adventure?</h2>
          <p>
            Find the perfect pontoon or tritoon trailer for your boat size and transport needs. Our single, tandem, and triple axle options
            provide the capacity and features you need for safe and reliable boat transport.
          </p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-primary">Get a quote</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PontoonTrailersPage;